{
  "title": "Oops, something went wrong",
  "description": "Something went wrong while performing the last action. Please refresh the page. If the issue persists or you need help, please contact Client Services.",
  "buttons": {
    "refresh": "Refresh page"
  }
}
